import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const isHomepage = location.pathname === '/';

  return (
    <footer className="border-t border-black/5 py-12 mt-20">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <Link to="/" className="font-display text-2xl text-charcoal tracking-tight">
              Rankum
            </Link>
            <p className="text-sm text-charcoal-light mt-2">
              Restaurant picks from regular St. Louis folks.
            </p>
          </div>

          {!isHomepage && (
            <Link
              to="/"
              className="link-underline text-charcoal-light hover:text-amber transition-colors text-sm"
            >
              Browse All Recommendations
            </Link>
          )}
        </div>

        <div className="border-t border-black/5 pt-8 mt-8">
          <p className="text-xs text-charcoal-light/60 text-center">
            © {new Date().getFullYear()} Rankum
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
